import { getRanaApiV1 } from "@nens/rana/api-v1";
import { useMutationWithErrorHandler } from "@nens/ranalib";
import { ApiError } from "@nens/react-query-utils";

import { useUpdatePublicationThumbnailQuery } from "@/queries/query-publication-thumbnail";

type RemovePublicationThumbnailProps = {
  publicationId: string;
};

export const useRemovePublicationThumbnail = () => {
  const update = useUpdatePublicationThumbnailQuery();

  return useMutationWithErrorHandler<void, ApiError, RemovePublicationThumbnailProps>(
    async ({ publicationId }) => {
      await getRanaApiV1().PublicationsApi.publicationThumbnailRemove({
        publicationId,
      });
      await update(publicationId, null);
    }
  );
};
